import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ApisService } from "@core/services/apis.service";
import { LanguageService } from "@core/services/language.service";
import { LoadingService } from "@core/services/loading.service";
import { TranslateService } from "@ngx-translate/core";
import {
  ColumnMode,
  DatatableComponent,
  SelectionType,
} from "@swimlane/ngx-datatable";
import Swal from "sweetalert2"; // optional for confirmation popup

@Component({
  selector: "app-articles",
  templateUrl: "./articles.component.html",
  styleUrls: ["./articles.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ArticlesComponent implements OnInit {
  public arrCoupons: any[] = [];
  lang: string;
 currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  constructor(
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
    private loading: LoadingService, 
    private language : LanguageService,private translate: TranslateService,
    private languageService: LanguageService
  ) {
     this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  this.translate.onLangChange.subscribe(lang => {
    this.currentLang = lang.lang;
  });
  }

  public currentPage = 1;
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
totalPages: number[] = [];

  public levels: any[] = [];
  public tempData = [];
  public articles: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe(lang => {
      this.lang = lang
    })
    this.loading.show();
    this.getarticles();

      this.languageService.applyCurrentLanguage();

  }

  getarticles() {
      this.loading.show(); // ✅ show loading before API call

  this.apisService.getArticles(this.currentPage).subscribe({
    next: (res: any) => {
      this.loading.hide(); // ✅ hide loading after API call

      this.articles = res.data.articles;
      this.totalItems = res.data.total; // ✅ use API's total if available


         // Create array of total pages
      const pages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.totalPages = Array.from({ length: pages }, (_, i) => i + 1);
    },
    error: () => {
      this.loading.hide(); // ✅ hide loading on error
    }
  });
  }

  addArticle() {
    this.router.navigate(["/add-article"]);
  }

 confirmDelete(id: number): void {
  this.translate.get([
    'MENU.DASHBOARD.CONFIRM_DELETE_TITLE',
    'MENU.DASHBOARD.CONFIRM_DELETE_TEXT',
    'MENU.DASHBOARD.YES_DELETE',
    'MENU.DASHBOARD.CANCEL',
    'MENU.DASHBOARD.DELETED_TITLE',
    'MENU.DASHBOARD.DELETED_TEXT',
    'MENU.DASHBOARD.ERROR_TITLE',
    'MENU.DASHBOARD.ERROR_TEXT',
    'MENU.DASHBOARD.OK'
  ]).subscribe(translations => {
    Swal.fire({
      title: translations['MENU.DASHBOARD.CONFIRM_DELETE_TITLE'],
      text: translations['MENU.DASHBOARD.CONFIRM_DELETE_TEXT'],
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: translations['MENU.DASHBOARD.YES_DELETE'],
      cancelButtonText: translations['MENU.DASHBOARD.CANCEL']
    }).then((result) => {
      if (result.isConfirmed) {
        this.apisService.deleteArticles(id).subscribe({
          next: () => {
            Swal.fire({
              title: translations['MENU.DASHBOARD.DELETED_TITLE'],
              text: translations['MENU.DASHBOARD.DELETED_TEXT'],
              icon: "success",
              confirmButtonText: translations['MENU.DASHBOARD.OK']
            });
            this.getarticles(); // ✅ Reload articles here
          },
          error: () => {
            Swal.fire({
              title: translations['MENU.DASHBOARD.ERROR_TITLE'],
              text: translations['MENU.DASHBOARD.ERROR_TEXT'],
              icon: "error",
              confirmButtonText: translations['MENU.DASHBOARD.OK']
            });
          }
        });
      }
    });
  });
}


  // example reload method
  loadBooks(): void {
    // your logic to refresh the table
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  /*----------  Pagination Functions   ----------*/
  next() {
    this.currentPage++;
    this.getarticles();
  }

  prev() {
    this.currentPage--;
    this.getarticles();
  }


       /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }
 
}
